module.exports = __webpack_public_path__ + "img/page2-3.e661f524.png";